// Whether an occurrence's status says it will not happen. One spelling list for every reader.
export const isCancelledStatus = (status) => ['cancelled', 'canceled'].includes(String(status || '').toLowerCase());

// An occurrence's sale status as a badge. `t` (first, like the other label helpers) is the caller's translator (the key carries
// its `labels:` namespace); a status this does not know shows as the provider sent it.
export const getStatusBadge = (t, status) => {
  switch (status?.toLowerCase()) {
    case 'on_sale':
    case 'onsale':
      return { text: t('labels:statuses.on_sale'), color: 'bg-applauss text-black' };
    case 'sold_out':
    case 'soldout':
      return { text: t('labels:statuses.sold_out'), color: 'bg-error text-white' };
    case 'cancelled':
    case 'canceled':
      return { text: t('labels:statuses.cancelled'), color: 'bg-destructive text-white' };
    case 'postponed':
      return { text: t('labels:statuses.postponed'), color: 'bg-warning text-white' };
    case 'rescheduled':
      return { text: t('labels:statuses.rescheduled'), color: 'bg-accent text-white' };
    case 'presale':
      return { text: t('labels:statuses.presale'), color: 'bg-primary text-white' };
    default:
      return { text: status || t('labels:statuses.available'), color: 'bg-muted text-muted-foreground' };
  }
};

export const getStatusDotColor = (dayOccs) => {
  if (!dayOccs || dayOccs.length === 0) return 'bg-primary';
  const statuses = dayOccs.map(o => o.status?.toLowerCase());
  if (statuses.some(s => s === 'on_sale' || s === 'onsale')) return 'bg-applauss';
  if (statuses.some(s => s === 'presale')) return 'bg-primary';
  if (statuses.some(s => s === 'rescheduled')) return 'bg-accent';
  if (statuses.some(s => s === 'postponed')) return 'bg-warning';
  if (statuses.some(s => s === 'sold_out' || s === 'soldout')) return 'bg-error';
  return 'bg-muted-foreground';
};
